module.exports = __webpack_public_path__ + "static/contact-916d8e70bfde51029a2b79224de2d7f9.svg";